export class ImportScheduleInfo {
    scheduleName! : string;
    buttonName! : string;
}